import { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { adminConfig } from "../../../utils/adminConfig";
import { message } from "antd";

export default function EscapeDollarCount() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    dollar: "",
    escapeDollars: "",
  });

  const getDollarCount = () => {
    setLoading(true);
    axios
      .get("/escape-bucks/get-dollar-count", adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setFormData({
            dollar: res.data.data.dollar,
            escapeDollars: res.data.data.escapeDollars,
          });
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };
  useState(() => {
    console.log("getDollarCount");
    getDollarCount();
  }, []);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const updateDollarCount = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post("/escape-bucks/update-dollar-count", formData, adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          message.success(res.data.message);
          getDollarCount();
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="cert_det_inner">
              <h2>Escape Credits Count</h2>
            </div>

            <Form onSubmit={updateDollarCount}>
              <Row>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Dollar ($)</Form.Label>
                    <Form.Control
                      type="number"
                      min={1}
                      placeholder="Dollar"
                      required
                      name="dollar"
                      value={formData.dollar}
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Escape Credits</Form.Label>
                    <Form.Control
                      type="number"
                      min={1}
                      placeholder="Escape Credits"
                      required
                      name="escapeDollars"
                      value={formData.escapeDollars}
                      onChange={handleOnChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="sub_but mt-3">
                <button type="submit" className="add_but submit_buttt mt-0">
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}
